export default {"src":"/_next/static/media/Dex-Badge-Dark.43d02939.gif","height":1080,"width":1920};